import type { PersonDto } from "../../../autogen/bff-api";

export const personName = (person: PersonDto): string =>
  [person.firstName, person.lastName].filter(Boolean).join(" ").trim() || person.email;

export const formatDateTime = (iso: string, locale = "nb-NO"): string => {
  if (!iso) return "";
  const date = new Date(iso);
  if (isNaN(date.getTime())) return iso;
  return date.toLocaleString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const stripRichText = (html: string): string =>
  html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const richTextHasContent = (html: string): boolean => stripRichText(html).length > 0;

// Compares two rich-text fragments by their visible text, ignoring markup and
// whitespace differences — used to tell whether the buyer actually reworded a question.
export const richTextEquals = (a: string, b: string): boolean => stripRichText(a) === stripRichText(b);
